import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1 className="header-title">Welcome To Signal</h1>
    </header>
  );
};

export default Header; 